module.exports = __webpack_public_path__ + "img/company2-2.3d13c34f.jpg";